"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightPaneContext = void 0;
exports.RightPaneProvider = RightPaneProvider;
exports.useRightPaneContext = useRightPaneContext;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importStar(require("react"));
exports.RightPaneContext = react_1.default.createContext({
    openInPane: () => { },
    closePane: () => { },
    clearPane: () => { },
    isRightPaneOpen: false,
    rightPaneContent: null,
});
function RightPaneProvider({ children }) {
    // Note: separating the pane content from isOpen state to prevent animating when updating content.
    const [rightPaneContent, setRightPaneContent] = (0, react_1.useState)(undefined);
    const [isRightPaneOpen, setIsRightPaneOpen] = (0, react_1.useState)(false);
    const openInPane = (0, react_1.useCallback)((opts) => {
        setRightPaneContent(opts === null || opts === void 0 ? void 0 : opts.content);
        setIsRightPaneOpen(true);
    }, [setRightPaneContent]);
    const closePane = (0, react_1.useCallback)(() => setIsRightPaneOpen(false), []);
    const clearPane = (0, react_1.useCallback)(() => setRightPaneContent(undefined), [setRightPaneContent]);
    const context = (0, react_1.useMemo)(() => ({ openInPane, closePane, clearPane, rightPaneContent, isRightPaneOpen }), [openInPane, closePane, rightPaneContent, clearPane, isRightPaneOpen]);
    return (0, jsx_runtime_1.jsx)(exports.RightPaneContext.Provider, { value: context, children: children });
}
function useRightPaneContext() {
    return (0, react_1.useContext)(exports.RightPaneContext);
}
